import { useCallback, useEffect, useState } from 'react'
import API from '../../../../services/API'

// Shared fetcher for KPI endpoints: GET `${path}?${query}` with loading/error
// state and a manual refetch.
const useKpi = (path, query) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [refreshIndex, setRefreshIndex] = useState(0)

  const refetch = useCallback(() => setRefreshIndex((index) => index + 1), [])

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    setError(false)
    API.get(`${path}?${query}`)
      .then((res) => {
        if (cancelled) return
        if (res.status === 200) setData(res.data)
        else setError(true)
      })
      .catch(() => {
        if (!cancelled) setError(true)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [path, query, refreshIndex])

  return { data, loading, error, refetch }
}

export default useKpi
